import Autocomplete from 'components/base/Autocomplete';
import usePmStatusesOptions from './usePmStatusesOptions';

const PmIssueStatesAutoComplete = ({ value, onChange }) => {
  const options = usePmStatusesOptions();

  return (
    <div>
      <Autocomplete
        width='20rem'
        multiple={false}
        selectedOptionValue={value}
        options={options}
        onChange={optionValue => {
          const { pmStatus } =
            options.find(option => option.value === optionValue) || {};
          return onChange(pmStatus);
        }}
      />
    </div>
  );
};

export default PmIssueStatesAutoComplete;
